<template>
  <div id="wrap" class="note_wrap">
  	<div class="note-text">
  		<el-input type="textarea" resize="none" v-if="flag" placeholder="在此记录你的想法..." v-model="noteCont" maxlength="2000" @keydown.native="listen($event)"></el-input>
  		<el-input type="textarea" resize="none" v-else placeholder="在此记录你的想法..." v-model="noteCont" maxlength="2000" @blur="iptBlur()" @keydown.native="listen($event)"></el-input>
  		<div class="bottom">
  			<el-checkbox v-model="checked">公开</el-checkbox>
  			<el-button type="primary" :disabled="disabledBtn" @click="addNote()" v-if="flag">保存</el-button
        >
  			<el-button type="primary" :disabled="disabledBtn" @click="editorNote()" v-else>保存</el-button>
  		</div>
  	</div>
  	<div class="note-list" v-if="$store.state.flag" v-loading="loading">
  		<div class="note-list-item" v-for="(item,index) in noteList" :key="index">
  			<div class="top">
  				<img src="/static/img/study/icon/zhangjie.png"/>
  				<span :title="item.catalogName">{{item.catalogName}}</span>
  			</div>
  			<div class="status">
  				<span :style="handleStatus(item.noteType)">{{item.noteType}}</span>
  			</div>
  			<div class="note-content">
  				<span class="m-content overflow-line"v-html="handleNote(item.content)"></span>
  				<el-button type="text" class="btn-more" v-if="item.content.length>51?isShowMore=true:isShowMore=false" id="J_btnmore" @click="showmoreDesc($event)">展开</el-button>
  			</div>
  			<div class="bottom">
  				<span class="time">{{item.date}}</span>
  				<ul class="right">
  					<li class="note_editor" @click="editNote(item,index)">
  						<div></div>
  					</li>
  					<li class="delete" @click="delNote(item.noteId)">
  						<div></div>
  					</li>
  				</ul>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
  import * as api from '../../../api/courseApi'
  export default {
    name: "note",
    data(){
    	return {
    		noteCont:'',
    		checked:false,
    		disabledBtn:true,
    		noteList:[],
    		noteId:'',
    		isShowMore:false,
    		isDescStatus:true,
    		flag:true,
    		editFlag:true,
    		loading:true
    	}
    },
    watch:{
    	noteCont(val){
    		val ? this.disabledBtn = false : this.disabledBtn = true;
    	}
    },
    created(){
    	this.getNoteList();
    },
    methods:{
    	// 获取笔记
    	getNoteList(){
    		let param = {
    			classId:this.$route.query.classId,
    			catalogId:this.$store.state.noteItem.id,
    			catalogName:this.$store.state.noteItem.catalogName
        }
        api.stuNoteByCatalog(param).then(res=>{
    			if(res.code == 0){
    				this.loading = false;
    				this.noteList = res.data;
    			}
    		}).catch(error=>{
    			console.log(error);
    		})
    	},
    	// 处理笔记换行
    	handleNote(str){
    		let newStr = ''
    		newStr = str.replace(/(\r\n|\n|\r)/gm, "<br/>");
    		return newStr;
    	},
    	// 新增笔记
    	addNote(){
        this.disabledBtn = true
    		if(!this.isNull(this.noteCont)){
    			this.loading = true;
    			let param = {
						content:this.noteCont,
						type:this.checked ? '0':'1',
						courseId:this.$route.query.id,
						classId:this.$route.query.classId,
						catalogId:this.$store.state.noteItem.id
          };
          api.addNote(param).then(res=>{
						if(res.code == 0){
							this.$messageSuccess('添加笔记成功');
							this.getNoteList();
							this.noteCont = '';
							this.checked = false;
							this.loading = false;
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error=>{
						console.log(error);
					})
    		}else{
    			this.$messageWarning('笔记内容不能全为空或空格');
      		return
        }
        this.disabledBtn = false
    	},
    	// 编辑笔记保存
    	editorNote(){
    		if(!this.isNull(this.noteCont)){
    			this.loading = true;
    			let param = {
						content:this.noteCont,
						type:this.checked ? '0':'1',
						id:this.noteId
          };
          api.editNote(param).then(res=>{
						console.log(res);
						if(res.code == 0){
							this.$messageSuccess('修改笔记成功');
							this.getNoteList();
							this.flag = true;
							this.noteCont = '';
							this.checked = false;
							this.editFlag = true;
							this.loading = false;
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error=>{
						console.log(error);
					})
    		}else{
    			this.$messageWarning('笔记内容不能全为空或空格');
      		return
    		}
    	},
    	isNull(str){
		    if (str == "") return true;
		    var regu = "^[ ]+$";
		    var re = new RegExp(regu);
		    return re.test(str);
			},
    	// 编辑笔记
    	editNote(data,index){
    		console.log(data);
    		if(this.editFlag){
    			this.noteList.splice(index,1);
    			this.editFlag = false;
    			this.noteCont = data.content;
    			this.checked = data.noteType == '已公开'? true:false;
    			this.noteId = data.noteId;
    			this.flag = false;
    		}else{
    			this.$messageWarning('请先保存当前正在编辑的笔记');
    			return false;
    		}
    	},
    	listen(e){
				if (event.keyCode === 13 && this.noteCont == "") {
	        event.preventDefault() // 阻止浏览器默认换行操作
	        return false
		    }
			},
    	// 处理状态颜色
      handleStatus(type){
      	let styleColor = {};
      	switch (type) {
      		case '已公开':
	      		styleColor = {
	      			border:'1px solid rgba(83,151,247,1)',
	        		color: '#5397F7'
	      		}
      		break;
      		case '未公开':
	      		styleColor = {
	      			border:'1px solid rgba(255,178,60,1)',
	        		color: '#FFB23C'
	      		}
      		break;
      	}
      	return styleColor
      },
      iptBlur(){
      	if(!this.noteCont){
      		this.$messageWarning('编辑中的笔记不能清空');
      		return false;
      	}
      },
      // 删除笔记
      delNote(id){
      	this.$tipsDialog(
      		"提示",
      		"确定删除该笔记吗？",
			    "确定后将删除该笔记下的全部评论",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
      	).then(() => {
          api.deleteNote({id:id}).then(res=>{
	      		console.log(res);
	      		if(res.code == 0){
	      			this.$messageSuccess('删除成功');
	      			this.getNoteList();
	      		}
	      	}).catch(error=>{
	      		console.log(error);
	      	})
        }).catch(() => {
//        this.$message({
//          type: 'info',
//          message: '已取消删除'
//        });
        });
      },
      // 展开
      showmoreDesc(e) {
        let el = e.currentTarget;
        el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
        el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
        el.innerHTML = !this.isDescStatus ? '展开' : '收起';
        this.isDescStatus = !this.isDescStatus;
        this.isShowMore = true;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .note_wrap {
    height: 100%;
    position: relative;
  	.note-text {
  		padding: 16px;
  		/deep/ .el-textarea__inner {
  			height: 120px;
  			font-size: 12px;
  		}
  		.bottom {
  			display: flex;
  			justify-content: space-between;
  			margin-top: 8px;
  			.el-button {
  				padding: 5px 15px;
  				font-size: 12px;
  			}
  			.el-button--primary.is-disabled {
  				background-color: #E6E6E6;
  				color: #999999;
  				border-color: #E6E6E6;
  			}
  		}
  	}
  	.note-list {
  		height: calc(100% - 186px);
  		overflow: auto;
  		padding-left: 16px;
  		padding-right: 13px;
  		.note-list-item {
				min-height:168px;
				background:rgba(255,255,255,1);
				border:1px solid rgba(230,230,230,1);
				opacity:1;
				border-radius:4px;
				padding: 12px 8px;
				margin-bottom: 12px;
				&:hover {
					box-shadow:0px 3px 6px rgba(216,216,216,0.92);
				}
				.top {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					margin-bottom: 8px;
					img {
						display: inline-block;
						width: 14px;
						height: 14px;
						margin-right: 4px;
					}
					span {
						display: inline-block;
						width: 155px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
				.status {
					border-bottom: 1px solid #E6E6E6;
					span {
						display: inline-block;
						width:48px;
						height:18px;
						line-height: 18px;
						text-align: center;
						opacity:1;
						border-radius:2px;
						font-size: 12px;
						margin-bottom: 8px;
					}
				}
				.note-content {
					margin: 8px 0;
					min-height: 72px;
				}
				.bottom {
					border-top: 1px solid #E6E6E6;
					display: flex;
					justify-content: space-between;
					align-items: flex-end;
					height: 28px;
					.time {
						color: #999999;
						font-size: 12px;
					}
					.right {
						li {
							float: left;
							border-right: 1px solid #E6E6E6;
							cursor: pointer;
							padding: 0 12px;
							div {
								width: 14px;
								height: 14px;
							}
							&:last-child {
								border: 0;
								padding-right: 0;
							}
						}
					}
					.note_editor {
						div {
							background: url(../../../../static/images/study/icon/bianji_hv.png) no-repeat;
							background-size: cover;
						}
						&:hover {
							div {
								background: url(../../../../static/images/study/icon/bianji.png) no-repeat;
								background-size: cover;
							}
						}
					}
					.delete {
						div {
							background: url(../../../../static/images/study/icon/shanchu_hv.png) no-repeat;
							background-size: cover;
						}
						&:hover {
							div {
								background: url(../../../../static/images/study/icon/shanchu.png) no-repeat;
								background-size: cover;
							}
						}
					}
				}
				.m-content {
					line-height: 20px;
					word-break: break-all;
					width: 95%;
			    &.overflow-line {
			      display: -webkit-box;
			      -webkit-box-orient: vertical;
			      -webkit-line-clamp: 4;
			      overflow: hidden;
			      float: left;
			    }
			  }
  		}
  	}
  }
</style>



// WEBPACK FOOTER //
// src/components/subcomponent/note/note.vue